import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { getSrcsetString } from 'dibs-image-utils/exports/srcSet';

// components
import { PdpSharedStoryTellingShopAllLink } from './PdpSharedStoryTellingShopAllLink';

// styles
import styles from './PdpSharedStoryTellingMainMedia.scss';

// types
import { type PdpSharedStoryTellingMainMedia_refactor_storyTellingTab$key as StoryTellingTab } from './__generated__/PdpSharedStoryTellingMainMedia_refactor_storyTellingTab.graphql';

const storyTellingTabQuery = graphql`
    fragment PdpSharedStoryTellingMainMedia_refactor_storyTellingTab on StoryTellingTab {
        tabTitle
        mainImage
        mainVideo
        ...PdpSharedStoryTellingShopAllLink_refactor_storyTellingTab
    }
`;

export const PdpSharedStoryTellingMainMedia: FC<{ storyTellingTab: StoryTellingTab }> = ({
    storyTellingTab: storyTellingTabRef,
}) => {
    const storyTellingTab = useFragment(storyTellingTabQuery, storyTellingTabRef);
    const { mainImage, mainVideo, tabTitle } = storyTellingTab;

    if (!mainImage && !mainVideo) {
        return null;
    }

    return (
        <div className={styles.mediaColumnWrapper}>
            {mainImage && (
                <img
                    alt=""
                    src={mainImage}
                    className={styles.mainMedia}
                    srcSet={getSrcsetString(mainImage)}
                    sizes="(max-width: 568px) 100vw, (max-width: 768px) 50vw, 42vw"
                />
            )}
            {mainVideo && (
                <iframe
                    height="100%"
                    width="100%"
                    allowFullScreen
                    src={mainVideo}
                    title={tabTitle}
                    className={`${styles.mainMedia} ${styles.mainVideo}`}
                />
            )}

            <PdpSharedStoryTellingShopAllLink storyTellingTab={storyTellingTab} />
        </div>
    );
};
